import { Component, computed, inject, OnInit, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentLoaderService, LoadableComponent } from '@melodic-ui/services';
import { IUser } from '../../api/mylb/interfaces/iuser.interface';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { TimezoneSelectorComponent } from '../timezone-selector/timezone-selector.component';
import { GlobalTimezoneService } from '../../services/global-timezone.service';
import { AccountStateService } from '@lb/state/account-state.service';
import { UserMenuComponent } from '../user-menu/user-menu.component';

@Component({
	selector: 'lb-page-banner',
	standalone: true,
	imports: [CommonModule, BreadcrumbComponent, TimezoneSelectorComponent, UserMenuComponent],
	templateUrl: './page-banner.component.html',
	styleUrl: './page-banner.component.scss'
})
export class PageBannerComponent implements OnInit {
	private readonly _accountStateService = inject(AccountStateService);
	private readonly _componentLoaderService = inject(ComponentLoaderService);
	private readonly _globalTimezoneService = inject(GlobalTimezoneService);

	public user: Signal<IUser> = this._accountStateService.user;

	public learnerTimezone = this._globalTimezoneService.learnerTimezone;
	public instructorTimezone = this._globalTimezoneService.instructorTimezone;
	public isReadonlyMode = this._globalTimezoneService.isReadonlyMode;
	public isAdmin = computed(() => this.user()?.entitlements?.some((e) => e.entitlementName === 'Admin:App:Access') ?? false);

	public mainContentComponent!: LoadableComponent;
	public menuContentComponent!: LoadableComponent;

	ngOnInit(): void {
		if (this._componentLoaderService.containers['banner-main-content']) {
			this.mainContentComponent = this._componentLoaderService.getContainer('banner-main-content');
		} else {
			this.mainContentComponent = this._componentLoaderService.addContainer('banner-main-content');
		}

		if (this._componentLoaderService.containers['banner-menu-content']) {
			this.menuContentComponent = this._componentLoaderService.getContainer('banner-menu-content');
		} else {
			this.menuContentComponent = this._componentLoaderService.addContainer('banner-menu-content');
		}
	}
}
